<template>
  <v-select
    :label="labelValue"
    :items="payFrequenciesList"
    v-model="payFrequencyValue"
    item-text="payFrequency"
    item-value="id"
    :rules="[requiredCheck()]"
    :disabled='disabled'
    :clearable="clearable"
    :readonly="readonly"
    :hide-details="hideDetails != null ? hideDetails : false"
    outlined
    :dense="dense ? dense : false"
  ></v-select>
</template>

<script>
import { mapActions } from 'vuex'
import { mapFields } from '@/vueHelpers/vuex'
import { required } from '@/lib/formValidations'

export default {
  props: [
    'label',
    'isRequired',
    'payFrequency',
    'disabled',
    'clearable',
    'readonly',
    'dense',
    'hideDetails'
  ],
  computed: {
    ...mapFields('payFrequencies', [
      'payFrequenciesList'
    ]),
    payFrequencyValue: {
      get () {
        return this.payFrequency
      },
      set (newValue) {
        this.$emit('payFrequencyChangeHandler', newValue)
      }
    },
    labelValue () {
      return this.label ? this.label : 'Pay Frequency'
    }
  },
  created () {
    this.getPayFrequencies()
  },
  methods: {
    ...mapActions('payFrequencies', [
      'getPayFrequencies'
    ]),
    requiredCheck () {
      return !this.isRequired || required('Pay Frequency')
    }
  }
}
</script>
